module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "registerSettlementForm",
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitActivation($event)
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v("Пренос активних фактура са једног правног лица на друго")])], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Са организације"
    }
  }, [_c('autocomplete', {
    ref: "sourceOrganizationAutocomplete",
    attrs: {
      "url": _vm.autoCompleteUrl_organization,
      "criteria": "companyNumber",
      "description": "name",
      "name": "sourceOrganization.companyNumber",
      "prepareResponseData": _vm.prepareResponseData,
      "hideDetails": ""
    },
    on: {
      "resolved": _vm.sourceOrganizationResolved
    },
    model: {
      value: (_vm.sourceOrganization.companyNumber),
      callback: function($$v) {
        _vm.$set(_vm.sourceOrganization, "companyNumber", $$v)
      },
      expression: "sourceOrganization.companyNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.sourceOrganization.companyNumber) ? _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_vm._v("ИД: "), _c('strong', [_vm._v(_vm._s(_vm.sourceOrganization.id))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("МБ: "), _c('strong', [_vm._v(_vm._s(_vm.sourceOrganization.companyNumber))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("ПИБ: "), _c('strong', [_vm._v(_vm._s(_vm.sourceOrganization.taxIdNumber))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Назив: "), _c('strong', [_vm._v(_vm._s(_vm.sourceOrganization.name))])])])], 1) : _vm._e(), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "На организацију"
    }
  }, [_c('autocomplete', {
    ref: "targetOrganizationAutocomplete",
    attrs: {
      "url": _vm.autoCompleteUrl_organization,
      "criteria": "companyNumber",
      "description": "name",
      "name": "targetOrganization.companyNumber",
      "prepareResponseData": _vm.prepareResponseData,
      "hideDetails": ""
    },
    on: {
      "resolved": _vm.targetOrganizationResolved
    },
    model: {
      value: (_vm.targetOrganization.companyNumber),
      callback: function($$v) {
        _vm.$set(_vm.targetOrganization, "companyNumber", $$v)
      },
      expression: "targetOrganization.companyNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.targetOrganization.companyNumber) ? _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_vm._v("ИД: "), _c('strong', [_vm._v(_vm._s(_vm.targetOrganization.id))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("МБ: "), _c('strong', [_vm._v(_vm._s(_vm.targetOrganization.companyNumber))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("ПИБ: "), _c('strong', [_vm._v(_vm._s(_vm.targetOrganization.taxIdNumber))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Назив: "), _c('strong', [_vm._v(_vm._s(_vm.targetOrganization.name))])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "disabled": _vm.load || !_vm.sourceOrganization.id || !_vm.targetOrganization.id
    }
  }, [_vm._v("\r\n            Пренеси активне фактуре\r\n            "), _c('loader', {
    attrs: {
      "show": _vm.load,
      "type": "button"
    }
  })], 1)], 1), _vm._v(" "), (_vm.showErrorContainer) ? _c('b-card', {
    staticClass: "m-1",
    attrs: {
      "no-body": "",
      "header-bg-variant": "success",
      "header": "Пренете фактуре",
      "header-text-variant": "white"
    }
  }, [_c('div', {
    staticClass: "list-container"
  }, [_c('b-list-group', _vm._l((_vm.transferredInvoices), function(invoice) {
    return _c('b-list-group-item', {
      key: invoice
    }, [_vm._v(_vm._s(invoice))])
  }), 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-840fae58", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-840fae58","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./src/components/home/intervention/move-invoices/move-invoices.html
// module id = 798
// module chunks = 1